export const UNITS_OF_MEASURE = [
  { id: "piece", name: "Piece" },
  { id: "kg", name: "Kg" },
  { id: "g", name: "Gram" },
  { id: "litre", name: "Litre" },
  { id: "ml", name: "Millilitre" },
  { id: "meter", name: "Meter" },
  { id: "box", name: "Box" },
  { id: "pack", name: "Pack" },
  { id: "set", name: "Set" },
  { id: "ream", name: "Ream" },
  { id: "dozen", name: "Dozen" },
  { id: "unit", name: "Unit" },
];

export const REQUISITION_STATUSES = {
  draft: { label: "Draft", color: "bg-gray-100 text-gray-800" },
  pending_approval: { label: "Pending Approval", color: "bg-yellow-100 text-yellow-800" },
  pending_manager_approval: { label: "Pending Manager Approval", color: "bg-orange-100 text-orange-800" },
  pending_owner_approval: { label: "Pending Owner Approval", color: "bg-yellow-100 text-yellow-800" },
  approved: { label: "Approved", color: "bg-green-100 text-green-800" },
  processing: { label: "Processing", color: "bg-blue-100 text-blue-800" },
  partially_fulfilled: { label: "Partially Fulfilled", color: "bg-indigo-100 text-indigo-800" },
  fulfilled: { label: "Fulfilled", color: "bg-emerald-100 text-emerald-800" },
  rejected: { label: "Rejected", color: "bg-red-100 text-red-800" },
  cancelled: { label: "Cancelled", color: "bg-gray-200 text-gray-600" },
};

export const PO_STATUSES = {
  draft: { label: "Draft", color: "bg-gray-100 text-gray-800" },
  pending_approval: { label: "Pending Approval", color: "bg-yellow-100 text-yellow-800" },
  approved: { label: "Approved", color: "bg-green-100 text-green-800" },
  ordered: { label: "Ordered", color: "bg-blue-100 text-blue-800" },
  partially_received: { label: "Partially Received", color: "bg-indigo-100 text-indigo-800" },
  received: { label: "Received", color: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-800" },
};

export const PRIORITY_LEVELS = [
  { id: "low", name: "Low", color: "bg-gray-100 text-gray-800" },
  { id: "medium", name: "Medium", color: "bg-yellow-100 text-yellow-800" },
  { id: "high", name: "High", color: "bg-orange-100 text-orange-800" },
  { id: "urgent", name: "Urgent", color: "bg-red-100 text-red-800" },
];

export const ASSET_CONDITIONS = [
  { id: "new", name: "New" },
  { id: "good", name: "Good" },
  { id: "fair", name: "Fair" },
  { id: "poor", name: "Poor" },
  { id: "damaged", name: "Damaged" },
];

export const PAYMENT_TERMS = [
  { id: "immediate", name: "Immediate" },
  { id: "net_15", name: "Net 15" },
  { id: "net_30", name: "Net 30" },
  { id: "net_45", name: "Net 45" },
  { id: "net_60", name: "Net 60" },
  { id: "on_delivery", name: "On Delivery" },
];
